define('TescoMobile_Checkout/js/action/set-about-information',['mage/storage', 'Magento_Checkout/js/model/url-builder', 'Magento_Checkout/js/model/quote', 'TescoMobile_Checkout/js/model/error-processor-multi-row', 'Magento_Checkout/js/model/full-screen-loader', 'TescoMobile_Checkout/js/action/agreements-assigner', 'uiRegistry', 'Magento_Customer/js/model/customer'], function (storage, urlBuilder, quote, errorProcessor, fullScreenLoader, agreementsAssigner, uiRegistry, customerData) {
  'use strict';

  const formatDate = function (date) {
    return date.join('-');
  };
  return function (messageContainer, aboutData, aboutStep) {
    let serviceUrl;
    if (customerData.isLoggedIn()) {
      serviceUrl = urlBuilder.createUrl('/carts/mine/set-about-information', {});
    } else {
      serviceUrl = urlBuilder.createUrl('/guest-carts/:cartId/set-about-information', {
        cartId: quote.getQuoteId()
      });
    }
    const customer = aboutData.customer,
      billing_address = aboutData.billing_address,
      previous_address = aboutData.previous_address;
    const previousAddressField = uiRegistry.get(aboutStep.name + '.about-fieldset.previous_address');
    if (customer !== null && customer !== void 0 && customer.dob) {
      const _customer$dob = customer.dob,
        year = _customer$dob.year,
        month = _customer$dob.month,
        day = _customer$dob.day;
      aboutData.customer.dob = formatDate([year, month, day]);
    }
    if (billing_address) {
      const billingAddressAddressSelector = uiRegistry.get(aboutStep.name + '.about-fieldset.billing_address.tm_address_selector');
      if (billingAddressAddressSelector.buildingId()) {
        aboutData.billing_address.tm_building_id = billingAddressAddressSelector.buildingId();
      }
      if (billing_address !== null && billing_address !== void 0 && billing_address.tm_start_date) {
        const _billing_address$tm_s = billing_address.tm_start_date,
          year = _billing_address$tm_s.year,
          month = _billing_address$tm_s.month;
        aboutData.billing_address.tm_start_date = formatDate([year, month]);
      }
      if (billing_address.postcode) {
        aboutData.billing_address.postcode = billingAddressAddressSelector.postcode();
      }
    }
    if (previous_address) {
      const previousAddressAddressSelector = uiRegistry.get(aboutStep.name + '.about-fieldset.previous_address.tm_address_selector');
      if (previousAddressAddressSelector.buildingId()) {
        aboutData.previous_address.tm_building_id = previousAddressAddressSelector.buildingId();
      }
      if (previous_address !== null && previous_address !== void 0 && previous_address.tm_start_date) {
        const _previous_address$tm_ = previous_address.tm_start_date,
          year = _previous_address$tm_.year,
          month = _previous_address$tm_.month;
        aboutData.previous_address.tm_start_date = formatDate([year, month]);
      }
      if (previous_address.postcode) {
        aboutData.previous_address.postcode = previousAddressAddressSelector.postcode();
      }
    }
    if (previousAddressField && !previousAddressField.visible()) {
      delete aboutData.previous_address;
    }
    if (customer && customer.constructor === Object && Object.keys(customer).length === 0) {
      delete aboutData.customer;
    }
    if (customer && aboutData.customer.hasOwnProperty('customer_email')) {
      delete aboutData.customer.customer_email;
    }
    agreementsAssigner(aboutData);
    const payload = {
      cartId: quote.getQuoteId(),
      about: aboutData
    };
    fullScreenLoader.startLoader();
    return storage.post(serviceUrl, JSON.stringify(payload)).done(function (response) {
      quote.setTotals(response.totals);
    }).fail(function (response) {
      errorProcessor.process(response, messageContainer);
    }).always(function () {
      fullScreenLoader.stopLoader();
    });
  };
});

